export default __webpack_public_path__ + "7bf6a7f5a8552b493e0919a9dd1025e6.jpg";